// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-text[data-v-614a6f0e] a{color:#faa836!important;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
